import { USER_ACTION_TYPE } from '../../../types';
import { buttonsText, errorMessage, labels, placeholder } from '../../../utils/constants';
import { useForm, FormProvider } from "react-hook-form";
import { MOBILE_VALIDATION } from '../../../lib/input/validation-rules';
import { supplierInfoData } from '../../../data/formData';
import { apiConstants } from '../../../utils/apiConstants';
import { useEffect, useState } from 'react';
import { getNumberWithIsd, getSelectedIsd, showToast, validatePhoneNumber } from '../../../utils';
import UserSnap from '../../../global/ui/UserSnap';
import VerifyPassword from '../../../components/modal/VerifyPassword';
import VerifyPhoneNumber from '../../../components/modal/VerifyMobNumber';
import RegisterLayout from '../crewProfileSetup/RegisterLayout';
import InputFieldV2 from '../../../lib/input/InputFieldV2';
import PhoneInputV2 from '../../../lib/input/Phoneinputv2';

interface infov2 {
  userData: any;
  onSubmit: (value: any) => void;
  actionType?: any;
  editedSuccessfully?: boolean;
  setEditedSuccessfully: () => void;
}
const InfoV2 = (props: infov2) => {

  const { ...methods } = useForm({
    mode: 'all',
    defaultValues: { ...supplierInfoData(props.userData) },
    reValidateMode: 'onBlur',
  });

  const [password, setPassword] = useState('');
  const [showPwdPopUp, setShowPwdPopUp] = useState(false);
  const [fieldData, setFieldData] = useState({});
  const [numberVerifyPopup, setNumberVerifyPopup] = useState(false);
  const [updatedField, setUpdatedField] = useState(false)

  const verifyPwd = (data: any) => {
    const pwdData = { ...fieldData, 'password': data.password }
    onSubmit(pwdData)
    setShowPwdPopUp(false);
    setFieldData({});
    setPassword('');
  }
  useEffect(() => {
    methods.setValue(apiConstants.profile_image, props.userData?.profile_image, { shouldValidate: true })
  }, [props?.userData]);

  useEffect(() => {
    if (props.editedSuccessfully && updatedField) {
      setNumberVerifyPopup(true);
    }
  }, [props.editedSuccessfully])
  useEffect(() => {
    if (props.userData?.mobile_number) {
      const [isdCode]: any = getNumberWithIsd(props.userData?.mobile_number);
      methods.setValue('dial_code', getSelectedIsd(isdCode))
    }
  }, [props.userData?.mobile_number])


  const onSubmit = (values: any) => {
    props.setEditedSuccessfully();
    const apiPayload = { ...values };
    if (values?.[apiConstants.mobile_number]) {
      if (values?.[apiConstants.mobile_number][0] !== '+') {
        apiPayload[apiConstants.mobile_number] = `${values?.dial_code?.dial_code}${values?.[apiConstants.mobile_number]}`
        if (!validatePhoneNumber(apiPayload?.[apiConstants.mobile_number])) {
          showToast(errorMessage.invalid_mobile_msg, 'error', 'mobile')
          return
        }
      }
    }
    if (apiPayload[apiConstants.mobile_number] == props?.userData?.[apiConstants.mobile_number]) {
      delete apiPayload[apiConstants.mobile_number]
    }
    else if (props?.actionType === 'update' && Object.keys(fieldData).length === 0) {
      setFieldData(apiPayload as never);
      setShowPwdPopUp(true);
      setUpdatedField(true)
      return;
    }
    if (methods.getValues(apiConstants.profile_image) == props.userData?.profile_image) {
      delete apiPayload[apiConstants.profile_image]
    }

    if (props?.actionType === USER_ACTION_TYPE.TYPE_UPDATE) {
      const firstSpaceIndex = apiPayload?.[apiConstants.contact_person].indexOf(' ');

      if (firstSpaceIndex !== -1) {
        apiPayload[apiConstants.first_name] = apiPayload?.[apiConstants.contact_person].substring(0, firstSpaceIndex);
        apiPayload[apiConstants.last_name] = apiPayload?.[apiConstants.contact_person].substring(firstSpaceIndex + 1);
      }
      else {
        apiPayload[apiConstants.first_name] = apiPayload?.[apiConstants.contact_person];
        apiPayload[apiConstants.last_name] = '';
      }
    }
    delete apiPayload[apiConstants.contact_person]
    //const fd = generateFormData(apiPayload);
    props.onSubmit(apiPayload)
  }
  return (
    <RegisterLayout hideHeader showLogout>
      <FormProvider {...methods} >
        <form action="" onSubmit={methods.handleSubmit(onSubmit)} noValidate>
          <div className="register-step">
            <div className="register-step__heading-block">
              <h1 className="register-step__title">A bit about<br />yourself</h1>
              <p className="register-step__description">
                Let’s get some info about you!
              </p>
            </div>
            <div>
              <div className="text-center">
                <UserSnap
                  onChange={(value) => methods.setValue(apiConstants.profile_image, value, { shouldValidate: true })}
                  value={methods.getValues(apiConstants.profile_image)}
                  label={labels.addLogo}
                  showImg
                />
              </div>
              {props?.actionType === USER_ACTION_TYPE.TYPE_UPDATE &&
                <div className="personal-info__field">
                  <label className="personal-info__label">{labels.supplierContactName}</label>
                  <InputFieldV2
                    placeholder={placeholder.supplierName}
                    name={apiConstants.contact_person}
                    type='text'
                    rules={{ required: false }}
                    maxLength={150}
                  />
                </div>
              }
              <div className="personal-info__field">
                <label className="personal-info__label">{labels.supplier_website}</label>
                <InputFieldV2
                  placeholder={placeholder.website_url}
                  name={apiConstants.website}
                  type='text'
                  rules={{
                    required: false
                  }}
                  maxLength={250}
                />
              </div>
              <div style={{ marginTop: 20 }} className="personal-info__field">
                <label className="personal-info__label">{labels.contactNumber}</label>
                <PhoneInputV2
                  name={apiConstants.mobile_number}
                  placeholder={placeholder.contactNumber}
                  rules={MOBILE_VALIDATION}
                  isDisabled={props?.actionType === USER_ACTION_TYPE.TYPE_UPDATE ? false : true}
                />
              </div>
            </div>
            <div className="register-step__footer">
              <button
                className="btn-next btn-next--yellow"
                type="submit"
              >
                {props?.actionType === USER_ACTION_TYPE.TYPE_UPDATE ? buttonsText.saveAndUpdate : buttonsText.continue}
              </button>
            </div>
            <VerifyPassword
              pwd={password}
              show={showPwdPopUp}
              closePopup={() => {
                setShowPwdPopUp(false);
                props.setEditedSuccessfully();
              }}
              onSubmit={verifyPwd}
            />
            <VerifyPhoneNumber
              show={numberVerifyPopup}
              closePopup={() => {
                setNumberVerifyPopup(false);
                props.setEditedSuccessfully();
              }}
            />
          </div>
        </form>
      </FormProvider>
    </RegisterLayout>
  )
}
export default InfoV2;